import { render } from "./outstore.vue?vue&type=template&id=5c6ca1e1"
import script from "./outstore.vue?vue&type=script&lang=js"
export * from "./outstore.vue?vue&type=script&lang=js"

import "./outstore.vue?vue&type=style&index=0&id=5c6ca1e1&lang=less"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__